import { FC, useState } from 'react';
import { Box, Paper, Stack, TextField, Typography } from '@mui/material';
import PhoneAndroidOutlinedIcon from '@mui/icons-material/PhoneAndroidOutlined';
import { useAppDispatch, useAppSelector } from '@hooks/redux-custom';
import { setDeliveryInstructions } from '@store/slices/order';
import { OrderSetupModal } from '@components';

export const DeliveryDetails: FC = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const { deliveryInstructions, recipient, shippingAddress } = useAppSelector((state) => state.order.value);
  const dispatch = useAppDispatch();

  const renderRecipientDetails = () => {
    if (recipient.type === 'OnlyCustomer' || recipient.type === 'SomeoneElse') {
      return (
        <Typography variant="body1">
          {recipient.first_name} {recipient.last_name}
          <br />
          <PhoneAndroidOutlinedIcon /> {recipient.phone}
        </Typography>
      );
    }

    if (recipient.type === 'AnyAdult') {
      return (
        <Typography variant="body1" data-testid="any-adult-response">
          Any adult at the address may accept this delivery.
        </Typography>
      );
    }
  };

  return (
    <>
      <Box padding={2} paddingLeft={1} data-testid="delivery-details">
        <Typography variant="h5" padding={2}>
          Delivery Details
        </Typography>
        <Paper elevation={2} sx={{ padding: 4 }}>
          <Stack spacing={2}>
            <Box>
              <Box display="flex" justifyContent="space-between" alignItems="flex-start">
                <Typography variant="h6">Recipient:</Typography>
              </Box>
              {renderRecipientDetails()}
            </Box>
            <Box>
              <Typography variant="h6">Shipping Address:</Typography>
              <Typography variant="body1">
                {shippingAddress?.company && (
                  <>
                    {shippingAddress?.company} <br />
                  </>
                )}
                {shippingAddress?.address2 ? `${shippingAddress?.address1}, ${shippingAddress?.address2}` : shippingAddress?.address1}
                <br />
                {shippingAddress?.city}
                <br />
                {shippingAddress?.state_or_province} {shippingAddress?.postal_code}
                <br />
                {shippingAddress?.country}
              </Typography>
            </Box>
            <Box>
              <TextField
                label="Delivery instructions"
                defaultValue={deliveryInstructions}
                fullWidth
                multiline
                rows={3}
                onChange={({ target: { value } }) => dispatch(setDeliveryInstructions(value))}
                inputProps={{ maxLength: 500 }}
              />
            </Box>
          </Stack>
        </Paper>
      </Box>
      <OrderSetupModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} />
    </>
  );
};
